import SiteButton_ButtonThreeDComponent from '../components/SiteButton/viewer/skinComps/BaseButton/ButtonThreeD.skin';
import SiteButton_ButtonThreeDController from '../components/SiteButton/viewer/SiteButton.controller';


const SiteButton_ButtonThreeD = {
  component: SiteButton_ButtonThreeDComponent,
  controller: SiteButton_ButtonThreeDController
};


export const components = {
  ['SiteButton_ButtonThreeD']: SiteButton_ButtonThreeD
};

